import { app } from '@/lib/app';
import { globeMarkerTemplates } from '@/lib/globe-marker-templates';
import { GlobeMarker, GlobeOptions } from '@/lib/types-util';
import { DisposeCallback, escapeHtml } from '@iyio/common';
import { useSubject } from '@iyio/react-common';
import type { GlobeInstance } from 'globe.gl';
import { useEffect, useState } from "react";

const defaultOptions:GlobeOptions={
    autoRotate:true,
}

interface GlobeRef
{
    globe:GlobeInstance;
}

export interface GlobeProps
{
    
}

export function Globe({

}:GlobeProps){

    const width=1.5;

    const [elem,setElem]=useState<HTMLElement|null>(null);
    const [globe,setGlobe]=useState<GlobeRef|null>(null);

    const optionsStack=useSubject(app().globeOptionsStackSubject);
    const options=optionsStack[optionsStack.length-1]??defaultOptions;
    
    useEffect(()=>{
        
        if(!globe){
            return;
        }
        const g=globe.globe;
        const controls=g.controls();
        
        if(options.autoRotate){
            controls.autoRotate=true;
            controls.autoRotateSpeed=options.rotateSpeed??0.3;
        }else{
            controls.autoRotate=false;
        }
        if(options.location){
            g.pointOfView({lat:options.location.lat,lng:options.location.lng,altitude:0.7},500);
        }else{
            g.pointOfView({altitude:2.5},1000);
        }
    },[globe,options]);

    const markers=useSubject(app().globeMarkersSubject);

    useEffect(()=>{
        if(!globe){
            return;
        }
        globe.globe
            .htmlElementsData(markers)
            .htmlElement(m=>{
                const marker=m as GlobeMarker;
                let html:string;
                if(marker.render){
                    html=marker.render(marker);
                }else if(marker.imageUrl){
                    html=`<img style="width:32px;height:32px;border-radius:4px;object-fit:cover" alt="Map Marker" src="${escapeHtml(marker.imageUrl)}"/>`;
                }else if(marker.template){
                    html=globeMarkerTemplates[marker.template]??`Unknown template - ${marker.template}`;
                }else{
                    html=`<pre><code>${JSON.stringify(marker,null,4)}</code></pre>`;
                }
                const div=document.createElement('div');
                div.style.position='relative';
                div.innerHTML=html;
                return div;
            });

        
        // globe.globe
        //     .pointsData(markers.map(m=>dump({
        //         lat:m.lat,
        //         lng:m.lng,
        //         size:0.5,
        //         color:'ffffff99',
        //     })))
        //     .pointAltitude('size')
        //     .pointColor('color')

    },[globe,markers]);

    useEffect(()=>{
        if(!elem){
            return;
        }

        let m=true;
        let dispose:DisposeCallback|undefined;

        import('globe.gl').then(({
            default:Globe
        })=>{
            if(!m){
                return;
            }

            

            const globe=new Globe(elem)
                .globeImageUrl('/globe/earth-blue-marble.jpg')
                .bumpImageUrl('/globe/earth-topology.png')
                //.backgroundImageUrl('/globe/night-sky.png');

            
            setGlobe({globe});

            const updateSize=()=>{
                globe.width(window.innerWidth*width);
                globe.height(window.innerHeight);
            }
            window.addEventListener('resize',updateSize);

            updateSize();

            dispose=()=>{
                window.removeEventListener('resize',updateSize);
            }

            
        });

        return ()=>{
            m=false;
            dispose?.();
        }

    },[elem]);

    return (
        <div className="fixed z-[-1] w-[100vw] h-[100vh] overflow-clip">
            <div ref={setElem}/>
            <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/30 to-black/80 pointer-events-none" />
        </div>
    )

}